module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.6.2/_next/static/images/capa-g1-1471c639264959dbb596914b11734cae.webp";